import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Loader from '../../../../shared/components/loader';
import CONSTANT from './../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
 import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Pagination from './../../../../shared/components/pagination'
import moment from 'moment';
import Util from './../../../../shared/util/util'
import TripServices from './../../../services/firstAndLastmilemanagement.service'


export default {
  name: 'UADCutoffs',
  components: {
    BasicSelect,
    VueElementLoading,
    DatePicker,
    moment,
    CustomExpandableTable,
    Pagination,
    TripServices
  },
  data() {
    return {
      awb: "",
      consigneecity: "",
      consigneename: "",
      consigneepincode: "",
      consignoraddress: "",
      consignorcity: "",
      consignorname: "",
      consignorpincode: "",
      destinationcity: "",
      originaldate: "",
      origincity: "",
      reason: "",
      rescheduledate: "",
      totalmps: "",
      otherreasonerr: "",
      totalwt: "",
      otherreason: "",
      id: "",
      servicereqNo: "",
      consigneeaddress: "",
      reasonType: 196,
      isLoading:false,
      showRaiseIssue:false,
      awbid : '',
      reasonlength:50,
      raiseissuereason : '',
      disablesubmit : 0
    }
  },
  computed: {},
  async mounted() {
    this.awbid = this.$route.params.id
    this.getUadraiselink();
    this.isLoading = true;

  },
  methods: {
    async getUadraiselink(){
    try {
      this.isLoading = true;
      let inputPayload = {
        "id": this.awbid
      }
      let result = await TripServices.getUadDataforraiselink(inputPayload);
      if(result.data.code == 200){
        this.awb = result.data.data.awb
        this.consigneecity = result.data.data.consigneecity
        this.consigneename = result.data.data.consigneename
        this.consigneepincode = result.data.data.consigneepincode
        this.consigneeaddress = result.data.data.consigneeaddress
        this.consignoraddress = result.data.data.consignoraddress
        this.consignorcity = result.data.data.consignorcity
        this.consignorname = result.data.data.consignorname
        this.consignorpincode = result.data.data.consignorpincode
        this.destinationcity = result.data.data.destinationcity
        this.originaldate = result.data.data.originaldate
        this.origincity = result.data.data.origincity
        this.reason = result.data.data.reason
        this.rescheduledate = result.data.data.rescheduledate
        this.totalmps = result.data.data.totalmps
        this.totalwt = result.data.data.totalwt
        this.id = result.data.data.id
          this.isLoading = false;
        }else{
          this.$router.push('/pages')
         this.isLoading = false;
         // this.$alert(result.data.message,'Raise Issue', "error");
        }
    } catch (error) {
      console.log(error)
      this.$router.push('/pages')
      this.isLoading = false;
    }
  },
  async createB2BTicketForUAD(){
    try {
      if(this.checkErr()){
        return false
      }
      this.isLoading = true;
      let inputPayload = {
        "shippingId":this.awb, // Parent AWB
        "reasonId":27, // Reason Id to mark Fake UAD
        "subReasonId":this.reasonType, // Sub Reason list is provided
        "comments":this.otherreason,
        "userId":299430, // Login User ID//fixed
        "userName":"dev.b2bapp@xpressbees.com", //fixed,
        "id" : this.id.toString()
      }
      if(this.reasonType=="196" && this.otherreason==""){
        inputPayload.comments = "Was not contacted"
      }
      if(this.reasonType=="197" && this.otherreason==""){
        inputPayload.comments = "Contacted but did not ask to re-schedule"
      }
      let result = await TripServices.createb2bticketforuad(inputPayload);
      if(result.data.code == 200){
        this.$alertify.success(result.data.message);
        if(this.reasonType == '196') {
          this.raiseissuereason = 'Was not contacted'
        }
        else if(this.reasonType == '197') {
          this.raiseissuereason = 'Contacted but did not ask to re-schedule'
        }
        else {
          this.raiseissuereason = this.otherreason
        }
         // this.$alert(result.data.message,'Raise Issue', "success");
         this.servicereqNo = result.data.data.ticketId;
         this.disablesubmit = 1
         this.showRaiseIssue = true;
          this.isLoading = false;
        }else{
         this.isLoading = false;
         this.$alert(result.data.message,'Raise Issue', "error");
        }
    } catch (error) {
      console.log(error)
      this.isLoading = false;
    }
  },
  closeRaiseIssue() {
   this.showRaiseIssue = false
   this.raiseissuereason = ''
   this.otherreason = "";
   this.reasonlength = 50;
   this.$validator.reset();
 },
 checkErr(){
  let err = false
  if(this.otherreason.length == 0 && this.reasonType=='198') {
    err = true
    this.$alert('Comments are required','Raise Issue', "error")
  }
  return err
},
countFunction(reason){
 this.reasonlength = 50 - reason.length
},
 createRaiseIssue(){
  this.showRaiseIssue =true;
 },

 onSubmit: function(event) {
   this.$validator.validateAll().then((result) => {
     if(result){
       this.createB2BTicketForUAD(event);
     }
   }).catch(() => {
     console.log('errors exist', this.errors)
   });
 },
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/configuration/raiseissue/raiseissue.component.js